import { render } from "./NonMedicarePayer.vue?vue&type=template&id=416122e8&ts=true"
import script from "./NonMedicarePayer.vue?vue&type=script&lang=ts"
export * from "./NonMedicarePayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__